export default "__VITE_ASSET__fXdqBgTB__"